<template>
  <div>
    <!-- Table Top -->
    <div class="m-2">
      <b-row>
        <!-- Cantidad de elementos por página -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <span>Mostrar</span>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
          />
        </b-col>
      </b-row>
    </div>
    <b-overlay
      rounded="sm"
      :show="isBusyTable"
      opacity="0"
    >
      <b-table
        ref="refDataListTable"
        class="position-relative"
        responsive
        :items="fetchData"
        :fields="tableColumns"
        :sort-desc.sync="isSortDirDesc"
        :sort-by.sync="sortBy"
        empty-text="No se encontraron resultados"
        primary-key="table_personas"
        show-empty
        striped
        table-variant="secondary"
        borderless
      >
        <template #cell(datos)="data">
          <p class="my-0">
            Matricula:<b :class="data.item.matricula ? 'text-primary' :'text-danger'">
              {{ data.item.matricula || 'Sin matricula' }}</b>
          </p>
          <p class="my-0">
            CURP: <b>{{ data.item.curp }}</b>
          </p>
          <small class="my-0">
            Principal: <b>{{ data.item.email }}</b>
          </small>
          <br>
          <small class="my-0">
            Alterno:<b> {{ data.item.emailAlt }}</b>
          </small>
          <br>
          <small class="my-0">
            Usuario:<b :class="data.item.cuenta ? '' :'text-warning'"> {{ data.item.cuenta || 'Sin usuario' }}</b>
          </small>
          <br>
          <small
            v-for="(plan) in data.item.planes"
            :key="`${plan.id}`"
            class="my-0"
          >
            <b> - {{ plan. nombre }} {{ plan.egresado ? '[Egresado]': '' }}</b>
            <br>
          </small>
        </template>

      </b-table>
    </b-overlay>
    <!-- Table's footer & pagination -->
    <div class="mx-2 mb-2">
      <b-row>
        <!-- Leyenda de cuantos elementos se muestran -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalItems"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol, BOverlay, BTable, BPagination,
} from 'bootstrap-vue'
import { useFillDataTable } from '@core/components/data-table/useFillDataTable'
import { configTablePersonas, fetchPersonas } from '@/views/components/persona/useBuscadorPersona'

import vSelect from 'vue-select'
import store from '@/store'
import { ref, onMounted, watch } from '@vue/composition-api'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BOverlay,
    BPagination,
    vSelect,
  },
  props: {
    busqueda: {
      type: Object,
      required: true,
    },
    buscar: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selected: [],
    }
  },
  setup(props, { emit }) {
    const { tableColumns } = configTablePersonas()
    const { configRequest } = fetchPersonas(props.busqueda)
    const errorContent = ref({ filters: false, table: false })
    const USER_APP_STORE_MODULE_NAME = 'app-user'
    const {
      fetchData, refetchData, refDataListTable,
      dataMeta,
      dynamicParamRequest,
      perPage, totalItems, currentPage, perPageOptions, searchQuery, sortBy, isSortDirDesc, dataAux,
      isBusyTable,
      errorRequest,
    } = useFillDataTable()
    isSortDirDesc.value = false

    onMounted(() => {
      dynamicParamRequest.value = configRequest.value //* Asign config params for each module as dynamic params
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })
    watch(errorRequest, error => { if (error) errorContent.value.table = error }) //* If the flag 'errorRequest' from data request is true, hide table content
    watch(configRequest.value, () => { refetchData() }) //* Any change in config params (filters), refetch table data
    watch(() => props.buscar, e => {
      if (e) refetchData(props.busqueda)
      emit('reiniciarBusqueda', false)
    })
    return {
      fetchData,
      dataAux,
      tableColumns,
      perPage,
      currentPage,
      totalItems,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataListTable,
      refetchData,
      isBusyTable,
      // Filter
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
